import { Button } from '@synergy-marine-group/synergy-ui';
import React from 'react';
import FilterIcon from '../../images/icons/filter.svg';

const FilterComponent = ({ setModal }) => {
  return (
    <div className="ml-4 self-stretch mt-1">
      <Button
        className=""
        rounded
        size="medium"
        variant="link"
        onClick={() => setModal(true)}
      >
        <div className="flex justify-center items-center  ">
          <img src={FilterIcon} alt="FilterIcon" className="mr-2" />
        </div>

      </Button>
    </div>
  );
};

export default FilterComponent;
